import { AbstractService } from '@uniqoders/sdk';
export default class UserService extends AbstractService {
    /**
     * Checks Sanctum Cookie on browser
     */
    async cookie() {
        return this.request('get', 'sanctum/csrf-cookie');
    }
    async register(data) {
        await this.cookie();
        await this.request('post', this.buildPath('/register'), [], data);
    }
    async login(form) {
        await this.cookie();
        await this.request('post', this.buildPath('/login'), [], form);
    }
    /**
     * Resets user password sending an email
     * @param data
     */
    async forgotPassword(data) {
        await this.cookie();
        return this.request('post', this.buildPath('/forgot-password'), [], data);
    }
    /**
     * Resets user password sending an email
     * @param data
     */
    async resetPasswords(data) {
        await this.cookie();
        return this.request('post', this.buildPath('/reset-password'), [], data);
    }
    /**
     * Logouts user on APP
     */
    logout() {
        return this.request('post', this.buildPath('/logout'), [], {});
    }
    /**
     * Checks if user is currently authenticated
     */
    async check() {
        await this.cookie();
        return await this.request('get', this.buildPath('/auth/check'));
    }
}
